import { defineComponent, createElementBlock, openBlock, createBlock, createCommentVNode, createElementVNode, createVNode, mergeProps, withCtx, toDisplayString, createTextVNode } from 'vue';
import _sfc_main$1 from './basler-components.es104.js';
/* empty css                        */
import _sfc_main$2 from './basler-components.es121.js';

const _hoisted_1 = { class: "cart-item" };
const _hoisted_2 = { class: "cart-item__content" };
const _hoisted_3 = { class: "cart-item__title" };
const _hoisted_4 = {
  key: 0,
  class: "cart-item__text"
};
const _hoisted_5 = { class: "cart-item__infos" };
const _hoisted_6 = { class: "cart-item__amount" };
const _hoisted_7 = { class: "cart-item__price" };
const _hoisted_8 = { class: "visually-hidden" };
const _hoisted_9 = ["aria-label"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "CartItem",
  props: {
    id: {},
    title: {},
    text: {},
    link: {},
    media: {},
    amountLabel: {},
    amount: {},
    priceLabel: {},
    price: {},
    removeActionLabel: {}
  },
  emits: ["remove", "navigate"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("article", _hoisted_1, [
        _ctx.media ? (openBlock(), createBlock(_sfc_main$1, {
          key: 0,
          media: _ctx.media,
          lazyload: true
        }, null, 8, ["media"])) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_2, [
          createVNode(_sfc_main$2, mergeProps(_ctx.link, {
            class: "cart-item__link",
            onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("navigate"))
          }), {
            default: withCtx(() => [
              createElementVNode("span", _hoisted_3, toDisplayString(_ctx.title), 1),
              _ctx.text ? (openBlock(), createElementBlock("p", _hoisted_4, toDisplayString(_ctx.text), 1)) : createCommentVNode("", true)
            ]),
            _: 1
          }, 16),
          createElementVNode("div", _hoisted_5, [
            createElementVNode("div", _hoisted_6, toDisplayString(_ctx.amountLabel) + ": " + toDisplayString(_ctx.amount), 1),
            createElementVNode("div", _hoisted_7, [
              createElementVNode("span", _hoisted_8, toDisplayString(_ctx.priceLabel) + ": ", 1),
              createTextVNode(toDisplayString(_ctx.price), 1)
            ])
          ])
        ]),
        _ctx.removeActionLabel ? (openBlock(), createElementBlock("button", {
          key: 1,
          type: "button",
          class: "cart-item__btn-remove",
          "aria-label": _ctx.removeActionLabel,
          onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("remove", _ctx.$props))
        }, null, 8, _hoisted_9)) : createCommentVNode("", true)
      ]);
    };
  }
});

export { _sfc_main as default };
